// Toggle entre paso 1 (oferta) y paso 2 (razones de cancelación) dentro
// del MISMO modal de retención. Replica el `useState(isCancel)` de
// CommunitySaasExtendedCancelModal.tsx y CommunitySaasExtendedNoTrialCancelModal.tsx.
//
// `dismissAndSubmit` cierra el modal client-side inmediatamente al aceptar la
// oferta. El POST a extend_trial/extend_current sigue en background y actualiza
// el panel + flash cuando responde — evita que la UI quede bloqueada mientras
// el server cobra Stripe (1-2s).

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["offer", "cancel"];

  showCancel() {
    this.offerTarget.classList.add("hidden");
    this.cancelTarget.classList.remove("hidden");
  }

  showOffer() {
    this.cancelTarget.classList.add("hidden");
    this.offerTarget.classList.remove("hidden");
  }

  dismiss() {
    const modal = this.application.getControllerForElementAndIdentifier(
      this.element,
      "manage--modal"
    );
    if (modal && typeof modal.close === "function") modal.close();
  }
}
